import { useEffect } from 'react'

// Locks document-level scrolling while a full-height app shell (demo/studio) is
// mounted. Without this, mobile Safari lets you drag the page body itself –
// dragging the non-scrollable header scrolls the whole document and slides the
// sticky header out of view, revealing the footer beneath. With the lock the
// document can't scroll at all; only the inner panes (overflow-y-auto) move.
export default function useAppShellLock() {
  useEffect(() => {
    const { documentElement } = document
    documentElement.classList.add('app-shell-locked')
    return () => {
      documentElement.classList.remove('app-shell-locked')
    }
  }, [])
}
